import { defineStyleConfig } from '@chakra-ui/react';

export const FormStyle = defineStyleConfig({
  baseStyle: {
    container: {
      px: '1px',
    },
  },
});
